define( '../src/sublayouts/_helpers/edit-toggle/edit-toggle',[ 'jquery', 'breakpoint', 'lib/utils', 'numeral' ], function ( $, breakpoint, utils ) {

	'use strict';

	/**
	 * Toggle menu - currently only triggers for mobile view only.
	 */

	var EditToggle = function ( $el ) {

		this.$el = $el;

		return this;
	};

	EditToggle.prototype.init = function () {

		//dom els
		this.$trigger = this.$el.find( '[data-edit-toggle-trigger]' );
		this.$fieldWrapper = this.$el.find( '[data-edit-toggle-field]' );
		this.$target = this.$el.find( '[data-edit-toggle-target]' );
		this.$input = this.$fieldWrapper.find( 'input' );
		this.$cancel = this.$el.find( '[data-edit-toggle-cancel]' );

		// classnames
		this.fieldOpenClassname = 'edit-toggle__field--open';
		this.originalAmount = parseFloat( this.$target.text() ).toFixed( 2 );

		// bind events
		this.$trigger.on( 'click', $.proxy( this.open, this ) );
		this.$cancel.on( 'click', $.proxy( this.close, this ) );
		this.$input.on( 'keyup', $.proxy( this.update, this ) );
	};

	EditToggle.prototype.open = function () {
		this.$trigger.hide();
		this.$fieldWrapper.addClass( this.fieldOpenClassname );
		this.$input.focus();
	};

	EditToggle.prototype.close = function () {
		this.$trigger.show();
		this.$input.val( '' );
		this.$target.text( numeral( this.originalAmount ).format('0,0.00') );
		this.$fieldWrapper.removeClass( this.fieldOpenClassname );
		this.$input.focus();
	};

	EditToggle.prototype.update = function () {
		this.$target.text( numeral( this.$input.val() ).format('0,0.00') );
	};

	return EditToggle;

} );

